import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { FolderListModel } from './types/folder-list-model.interface';
import { FolderListModelImpl } from './models/folder-list-model';
import { FolderListService } from './types/folder-list-service.interface';
import { FolderListApi } from './types/folder-list-api.interface';
import { FolderListServiceImpl } from './services/folder-list-service';
import { FolderListApiImpl } from './repository/folder-list-api';
import { FolderListStatusService } from './types/folder-list-status-service.interface';
import { FolderListStatusServiceImpl } from './services/folder-list-status-service';
import { FolderTreeService } from './types/folder-list-tree-service.interface';
import { FolderTreeServiceImpl } from './services/folder-list-tree-service';
import { FolderListApiDto } from './types/folder-list-api-dto.interface';
import { FolderListApiDtoImpl } from './repository/folder-list-api-dto';
export const folderList = new ContainerModule((bind) => {
    bind(FolderListModel).to(FolderListModelImpl);
    bind(FolderListService).to(FolderListServiceImpl);
    bind(FolderListApi).to(FolderListApiImpl);
    bind(FolderListApiDto).to(FolderListApiDtoImpl);
    bind(FolderListStatusService).to(FolderListStatusServiceImpl);
    bind(FolderTreeService).to(FolderTreeServiceImpl);
});
